<template>
  <div>
    <el-form class="toolbar" :inline="true" @keyup.enter.native="search">
      <el-form-item label="销售单号"><el-input v-model="query.code" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="客户名称"><el-input v-model="query.partnerName" size="small" clearable style="width:150px" /></el-form-item>
      <el-form-item label="状态">
        <el-select v-model="query.status" size="small" clearable style="width:110px">
          <el-option label="开立" value="0" /><el-option label="已确认" value="2" />
        </el-select>
      </el-form-item>
      <el-form-item><el-button type="primary" size="small" @click="search">查询</el-button></el-form-item>
      <el-form-item><el-button v-if="isAuth('sale:salesOrder:save')" type="primary" size="small" @click="open()">新增</el-button></el-form-item>
      <el-form-item>
        <el-button
          v-if="isAuth('production:productionOrder:fromSales')"
          type="primary"
          size="small"
          :disabled="!selection.length"
          @click="mergePushHandle"
        >合并下推生产</el-button>
      </el-form-item>
    </el-form>
    <el-table :data="list" border v-loading="loading" :header-cell-style="headStyle" @selection-change="selection = $event" @row-dblclick="row => open(row.salesOrderId, true)">
      <el-table-column type="selection" width="45" header-align="center" align="center" :selectable="row => row.orderStatus === '2'" />
      <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
      <el-table-column prop="salesOrderCode" label="销售单号" min-width="140" header-align="center" align="left">
        <template slot-scope="scope">
          <a v-if="isAuth('sale:salesOrder:info')" class="code-link" @click="open(scope.row.salesOrderId, true)">{{ scope.row.salesOrderCode }}</a>
          <span v-else>{{ scope.row.salesOrderCode }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="customerName" label="客户" min-width="140" header-align="center" align="left" show-overflow-tooltip />
      <el-table-column prop="orderDate" label="订购日期" width="110" header-align="center" align="left" />
      <el-table-column prop="totalQuantity" label="总数量" width="100" header-align="center" align="left" />
      <el-table-column prop="shippedQuantity" label="已出库" width="100" header-align="center" align="left" />
      <el-table-column prop="totalAmount" label="总金额" width="110" header-align="center" align="left" />
      <el-table-column label="状态" width="90" header-align="center" align="center">
        <template slot-scope="scope">
          <el-tag :type="scope.row.orderStatus === '2' ? 'success' : 'info'" size="small">{{ scope.row.orderStatus === '2' ? '已确认' : '开立' }}</el-tag>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination class="list-pagination" background :current-page="pageIndex" :page-sizes="[20, 50, 100]" :page-size="pageSize" :total="total"
      layout="total, sizes, prev, pager, next, jumper" @size-change="s => { pageSize = s; search() }" @current-change="p => { pageIndex = p; load() }" />

    <el-dialog :close-on-click-modal="false" :visible.sync="visible" width="90%" top="4vh" append-to-body>
      <template slot="title">
        <div class="doc-dialog-header">
          <span class="doc-dialog-title">{{ dialogTitle }}</span>
          <div v-if="readonly && form.salesOrderId" class="doc-dialog-actions">
            <el-button-group>
              <el-button v-if="isAuth('production:productionOrder:fromSales') && form.orderStatus === '2'" type="primary" size="small" @click="pushProductionHandle">下推生产</el-button>
              <el-button v-if="isAuth('sale:salesOrder:confirm') && form.orderStatus !== '2'" type="primary" size="small" @click="confirmOrder">确认</el-button>
              <el-button v-if="form.orderStatus === '2' && (isAuth('sale:salesOrder:unconfirm') || isAuth('sale:salesOrder:confirm'))" type="primary" size="small" @click="unconfirmOrder">反确认</el-button>
              <el-button v-if="isAuth('sale:salesOrder:update')" type="primary" size="small" :disabled="form.orderStatus === '2'" @click="editFromView">修改</el-button>
              <el-button v-if="isAuth('sale:salesOrder:delete')" type="primary" size="small" :disabled="form.orderStatus === '2'" @click="remove(form)">删除</el-button>
            </el-button-group>
          </div>
        </div>
      </template>
      <el-form :model="form" label-width="90px" :disabled="readonly">
        <el-row :gutter="12">
          <el-col :span="6">
            <el-form-item label="销售单号" :required="!codeReadonly && !form.salesOrderId"><el-input v-model="form.salesOrderCode" :readonly="codeReadonly || !!form.salesOrderId" /></el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="订购日期" required><el-date-picker v-model="form.orderDate" type="date" value-format="yyyy-MM-dd" style="width:100%" /></el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="客户" required>
              <el-input :value="form.customerName" readonly placeholder="请选择客户">
                <el-button v-if="!readonly" slot="append" @click="customerVisible = true">选择</el-button>
              </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="状态">
              <el-tag v-if="form.orderStatus === '2'" type="success" size="small">已确认</el-tag>
              <el-tag v-else type="info" size="small">开立</el-tag>
            </el-form-item>
          </el-col>
        </el-row>
        <el-form-item label="备注"><el-input v-model="form.remark" /></el-form-item>
      </el-form>
      <div v-if="!readonly" style="margin-bottom:10px">
        <el-button type="primary" size="small" @click="materialVisible = true">选择物料</el-button>
        <el-button type="primary" size="small" @click="addLine">新增行</el-button>
        <el-button v-if="priceEnabled && form.customerId && form.lines.length" type="primary" size="small" @click="resolvePrices">从价目表取价</el-button>
      </div>
      <el-table :key="readonly ? 'sales-order-view' : 'sales-order-edit'" ref="salesLinesTable" :data="form.lines" border :header-cell-style="headStyle">
        <el-table-column type="index" label="序号" width="60" header-align="center" align="center" />
        <el-table-column prop="materialCode" label="产品编码" min-width="160" header-align="center" align="left">
          <template slot-scope="scope">
            <el-input v-model="scope.row.materialCode" :disabled="readonly" placeholder="产品编码" @blur="fillMaterial(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column prop="materialName" label="产品名称" min-width="180" header-align="center" align="left" show-overflow-tooltip />
        <el-table-column prop="specs" label="规格" min-width="120" header-align="center" align="left" show-overflow-tooltip />
        <el-table-column label="订购数量" width="150" header-align="center" align="right">
          <template slot-scope="scope">
            <el-input-number v-model="scope.row.quantity" :min="Number(scope.row.shippedQuantity || 0)" :precision="2" :disabled="readonly" style="width:100%" @change="calc(scope.row)" />
          </template>
        </el-table-column>
        <el-table-column v-if="form.salesOrderId && !readonly" prop="shippedQuantity" label="已出库" width="90" header-align="center" align="right" />
        <el-table-column label="含税单价" width="150" header-align="center" align="right">
          <template slot-scope="scope"><el-input-number v-model="scope.row.price" :min="0" :precision="2" :disabled="readonly" style="width:100%" @change="calc(scope.row)" /></template>
        </el-table-column>
        <el-table-column label="税点" width="110" header-align="center" align="center">
          <template slot-scope="scope">
            <el-select v-model="scope.row.tax" :disabled="readonly" placeholder="税点" style="width:100%">
              <el-option v-for="item in taxes" :key="item.dictValue" :label="item.dictLabel" :value="Number(item.dictValue)" />
              <el-option v-if="hasLegacyTax(scope.row.tax)" :label="taxLabel(scope.row.tax)" :value="Number(scope.row.tax)" />
            </el-select>
          </template>
        </el-table-column>
        <el-table-column label="交货日期" width="150" header-align="center" align="center">
          <template slot-scope="scope"><el-date-picker v-model="scope.row.deliveryDate" type="date" value-format="yyyy-MM-dd" :disabled="readonly" style="width:100%" placeholder="交货日期" /></template>
        </el-table-column>
        <el-table-column label="备注" min-width="180" header-align="center" align="left">
          <template slot-scope="scope"><el-input v-model="scope.row.remark" maxlength="500" :disabled="readonly" placeholder="备注" /></template>
        </el-table-column>
        <el-table-column label="行金额" width="110" header-align="center" align="right">
          <template slot-scope="scope">{{ amount(scope.row) }}</template>
        </el-table-column>
        <el-table-column v-if="showProductionProgress" prop="productionAllocatedQty" label="已分配生产" width="100" header-align="center" align="right">
          <template slot-scope="scope">{{ formatQty(scope.row.productionAllocatedQty) }}</template>
        </el-table-column>
        <el-table-column v-if="showProductionProgress" prop="productionReceivedQty" label="已完工入库" width="100" header-align="center" align="right">
          <template slot-scope="scope">{{ formatQty(scope.row.productionReceivedQty) }}</template>
        </el-table-column>
        <el-table-column v-if="showProductionProgress" label="生产进度" width="90" header-align="center" align="center">
          <template slot-scope="scope">{{ formatProductionProgress(scope.row) }}</template>
        </el-table-column>
        <el-table-column v-if="showProductionProgress" prop="remainProductionQty" label="可下推生产" width="100" header-align="center" align="right">
          <template slot-scope="scope">{{ formatQty(scope.row.remainProductionQty) }}</template>
        </el-table-column>
        <el-table-column v-if="readonly && form.salesOrderId" prop="shippedQuantity" label="已出库" width="90" header-align="center" align="right" />
        <el-table-column label="可用库存" width="110" header-align="center" align="right">
          <template slot-scope="scope"><span :class="{ warn: Number(scope.row.quantity) > Number(scope.row.usableQuantity || 0) }">{{ scope.row.usableQuantity || 0 }}</span></template>
        </el-table-column>
        <el-table-column v-if="!readonly" label="操作" width="70" header-align="center" align="center">
          <template slot-scope="scope"><el-button type="text" size="small" :disabled="Number(scope.row.shippedQuantity) > 0" @click="removeLine(scope.$index)">删除</el-button></template>
        </el-table-column>
      </el-table>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visible = false">取消</el-button>
        <el-button v-if="!readonly" type="primary" @click="save">确定</el-button>
      </span>
    </el-dialog>
    <customer-selector :visible.sync="customerVisible" @select="chooseCustomer" />
    <material-selector :visible.sync="materialVisible" :multiple="true" @select-multiple="chooseMaterials" />
    <production-push-from-sales v-if="pushProductionVisible" ref="pushProduction" @success="onPushSuccess" />
    <production-push-merge-from-sales v-if="mergePushVisible" ref="mergePush" @success="onPushSuccess" />
  </div>
</template>

<script>
import CustomerSelector from '../../components/CustomerSelector.vue'
import MaterialSelector from '../../components/MaterialSelector.vue'
import ProductionPushFromSales from '../production/production-push-from-sales.vue'
import ProductionPushMergeFromSales from '../production/production-push-merge-from-sales.vue'
import { docAction, docGet, docInfo, docList, docSave } from '../../api/erp/doc'
import { getMaterialByCode } from '../../api/base/material'
import { resolveSalePriceListPrices } from '../../api/sale/salePriceList'
import { fetchPerms } from '../../api/auth'
import request from '../../api/request'
import { isConfigEnabled, SALE_PRICE_LIST_ENABLE_PARAM } from '../../api/sys/param'

export default {
  name: 'SalesOrder',
  components: { CustomerSelector, MaterialSelector, ProductionPushFromSales, ProductionPushMergeFromSales },
  data() {
    return {
      query: { code: '', partnerName: '', status: '' },
      list: [], selection: [], pageIndex: 1, pageSize: 20, total: 0, loading: false, hasActivated: false,
      visible: false, readonly: false, codeReadonly: false, form: { lines: [], orderStatus: '0' },
      customerVisible: false, materialVisible: false, taxes: [], originalTaxes: {}, priceEnabled: false, permCodes: [],
      pushProductionVisible: false, mergePushVisible: false,
      headStyle: { background: '#f5f7fa', color: '#606266' }
    }
  },
  computed: {
    dialogTitle() {
      if (this.readonly) return '查看销售订单'
      return this.form.salesOrderId ? '修改销售订单' : '新增销售订单'
    },
    showProductionProgress() {
      return !!this.form.salesOrderId && String(this.form.orderStatus) === '2'
    }
  },
  created() {
    this.loadPerms()
    this.load()
    request.get('/sys/dicts', { params: { dictType: 'TAX' } }).then(res => { this.taxes = res.data || [] }).catch(() => {})
    isConfigEnabled(SALE_PRICE_LIST_ENABLE_PARAM).then(enabled => {
      this.priceEnabled = enabled
    }).catch(() => { this.priceEnabled = false })
  },
  activated() {
    if (this.hasActivated) this.load()
    else this.hasActivated = true
  },
  methods: {
    editFromView() {
      this.readonly = false
      this.$nextTick(() => {
        if (this.$refs.salesLinesTable) this.$refs.salesLinesTable.doLayout()
      })
    },
    isAuth(perm) {
      const user = this.$store.state.user || {}
      const codes = Array.isArray(user.roleCodes) ? user.roleCodes : []
      const role = String(user.roleCode || '')
      if (role === 'TENANT_ADMIN' || role === 'PLATFORM_ADMIN' || codes.indexOf('TENANT_ADMIN') >= 0 || codes.indexOf('PLATFORM_ADMIN') >= 0) return true
      return this.permCodes.indexOf(perm) >= 0
    },
    loadPerms() { fetchPerms().then(res => { this.permCodes = res.data || [] }).catch(() => {}) },
    search() { this.pageIndex = 1; this.load() },
    load() {
      this.loading = true
      docList('/sale/salesOrder', { ...this.query, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    today() {
      const d = new Date()
      const p = n => String(n).padStart(2, '0')
      return d.getFullYear() + '-' + p(d.getMonth() + 1) + '-' + p(d.getDate())
    },
    open(id, readonly) {
      if (id && readonly && !this.isAuth('sale:salesOrder:info')) return
      this.readonly = !!readonly
      this.codeReadonly = false
      this.originalTaxes = {}
      this.form = { lines: [], orderStatus: '0', orderDate: this.today() }
      this.visible = true
      if (id) docInfo('/sale/salesOrder', id).then(res => { this.form = res.data || { lines: [] }; this.normalizeTaxes(); this.refreshLinesUsable() })
      else this.resolveCode()
    },
    normalizeTaxes() {
      this.originalTaxes = {}
      this.form.lines = (this.form.lines || []).map(line => {
        const tax = line.tax == null || line.tax === '' ? line.tax : Number(line.tax)
        if (line.salesOrderLineId && tax != null && tax !== '') this.originalTaxes[line.salesOrderLineId] = tax
        return { ...line, tax }
      })
    },
    taxLabel(value) {
      if (value == null || value === '') return '—'
      const item = this.taxes.find(tax => Number(tax.dictValue) === Number(value))
      return item ? item.dictLabel : String(value)
    },
    hasLegacyTax(value) {
      return value != null && value !== '' && !this.taxes.some(tax => Number(tax.dictValue) === Number(value))
    },
    materialTax(value) {
      if (value == null || value === '') return value
      const tax = Number(value)
      if (!Number.isFinite(tax)) return value
      const values = this.taxes.map(item => Number(item.dictValue))
      if (values.includes(tax)) return tax
      // 历史物料用 13 表示 13%，当前字典用 0.13。
      if (tax > 1 && values.includes(tax / 100)) return tax / 100
      return tax
    },
    resolveCode() {
      request.post('/base/docNumberRule/resolve', { docType: 'salesOrder' }).then(res => {
        const data = res.data || {}
        this.codeReadonly = !!data.codeReadonly
        if (data.previewCode) this.form.salesOrderCode = data.previewCode
      }).catch(() => {})
    },
    chooseCustomer(row) {
      this.form.customerId = row.customerId
      this.form.customerName = row.customerName
      if (this.priceEnabled && this.form.lines.length) this.resolvePrices()
    },
    addLine() {
      this.form.lines.push({ quantity: 1, shippedQuantity: 0, usableQuantity: 0, price: undefined, tax: undefined, remark: '' })
    },
    chooseMaterials(rows) {
      rows.forEach(row => {
        const found = this.form.lines.find(line => line.materialId === row.materialId)
        if (found) {
          found.quantity = Number(found.quantity || 0) + 1
          this.calc(found)
        } else {
          this.form.lines.push({
            materialId: row.materialId, materialCode: row.materialCode, materialName: row.materialName, specs: row.specs,
            quantity: 1, shippedQuantity: 0, usableQuantity: row.usableQuantity || 0, price: row.price, tax: this.materialTax(row.tax), remark: ''
          })
        }
      })
      if (this.priceEnabled && this.form.customerId) this.resolvePrices()
      this.refreshLinesUsable()
    },
    fillMaterial(line) {
      if (!line.materialCode) return
      getMaterialByCode(line.materialCode).then(res => {
        const row = res.data
        if (!row) { this.$message.warning('产品编码不存在：' + line.materialCode); return }
        line.materialId = row.materialId
        line.materialName = row.materialName
        line.specs = row.specs
        line.usableQuantity = row.usableQuantity || 0
        this.refreshLinesUsable()
      }).catch(() => {})
    },
    refreshLinesUsable() {
      const lines = (this.form.lines || []).filter(line => line && line.materialId)
      const materialIds = [...new Set(lines.map(line => line.materialId))]
      if (!materialIds.length) return
      request.post('/inventory/quantity/usableSums', { materialIds }).then(res => {
        const sums = res.data || {}
        lines.forEach(line => this.$set(line, 'usableQuantity', sums[line.materialId] == null ? 0 : sums[line.materialId]))
      }).catch(() => {})
    },
    calc(line) {
      const price = Number(line.price || 0)
      const qty = Number(line.quantity || 0)
      line.amount = (price * qty).toFixed(2)
    },
    amount(line) {
      return ((Number(line.price) || 0) * (Number(line.quantity) || 0)).toFixed(2)
    },
    formatQty(val) {
      if (val == null || val === '') return '—'
      const n = Number(val)
      if (Number.isNaN(n)) return '—'
      return n.toLocaleString('zh-CN', { minimumFractionDigits: 0, maximumFractionDigits: 2 })
    },
    formatProductionProgress(row) {
      const allocated = Number(row.productionAllocatedQty || 0)
      const received = Number(row.productionReceivedQty || 0)
      if (allocated <= 0) return '—'
      return Math.min(100, Math.round(received / allocated * 100)) + '%'
    },
    removeLine(index) {
      const line = this.form.lines[index]
      if (Number(line.shippedQuantity) > 0) {
        this.$message.warning('已有出库记录的明细行不允许删除')
        return
      }
      this.form.lines.splice(index, 1)
    },
    validate() {
      if (!this.form.lines.length) { this.$message.warning('请至少维护一条明细'); return false }
      const taxes = this.taxes.map(item => Number(item.dictValue))
      for (let i = 0; i < this.form.lines.length; i++) {
        const line = this.form.lines[i]
        const n = i + 1
        if (!line.materialCode) { this.$message.warning('第' + n + '行：产品编码不能为空'); return false }
        if (!(Number(line.quantity) > 0)) { this.$message.warning('第' + n + '行：订购数量必须大于0'); return false }
        if (Number(line.quantity) < Number(line.shippedQuantity || 0)) { this.$message.warning('第' + n + '行：订购数量不能小于已出库数量'); return false }
        if (line.price === undefined || line.price === null || line.price === '') { this.$message.warning('第' + n + '行：含税单价不能为空'); return false }
        if (line.tax === undefined || line.tax === null || line.tax === '') { this.$message.warning('第' + n + '行：税点不能为空'); return false }
        const originalTax = this.originalTaxes[line.salesOrderLineId]
        if (taxes.length && taxes.indexOf(Number(line.tax)) < 0 && Number(line.tax) !== originalTax) { this.$message.warning('第' + n + '行：税点字典项无效，请重新选择'); return false }
        if (!line.deliveryDate) { this.$message.warning('第' + n + '行：交货日期不能为空'); return false }
      }
      return true
    },
    save() {
      if (!this.validate()) return
      this.form.lines.forEach(line => { line.amount = this.amount(line) })
      docSave('/sale/salesOrder', this.form, 'salesOrderId').then(() => {
        this.$message.success('保存成功')
        this.visible = false
        this.load()
      }).catch(() => {})
    },
    confirmOrder() {
      this.$confirm('确认后将不可修改订单，是否继续?', '提示', { type: 'warning' }).then(() => {
        docAction('/sale/salesOrder', 'confirm', { salesOrderId: this.form.salesOrderId }).then(() => {
          this.$message.success('确认成功')
          this.open(this.form.salesOrderId, true)
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    unconfirmOrder() {
      this.$confirm('反确认后订单恢复为开立状态，可再次修改，是否继续?', '提示', { type: 'warning' }).then(() => {
        docAction('/sale/salesOrder', 'unconfirm', { salesOrderId: this.form.salesOrderId }).then(() => {
          this.$message.success('反确认成功')
          this.open(this.form.salesOrderId, true)
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    remove(row) {
      this.$confirm('确定删除该销售订单?', '提示', { type: 'warning' }).then(() => {
        docAction('/sale/salesOrder', 'delete', { salesOrderId: row.salesOrderId }).then(() => {
          this.$message.success('删除成功')
          this.visible = false
          this.load()
        }).catch(() => {})
      }).catch(() => {})
    },
    pushProductionHandle() {
      if (!this.form || !this.form.salesOrderId) return
      this.pushProductionVisible = true
      this.$nextTick(() => this.$refs.pushProduction && this.$refs.pushProduction.init(this.form.salesOrderId))
    },
    mergePushHandle() {
      const orders = (this.selection || []).filter(r => r && r.salesOrderId && String(r.orderStatus) === '2')
      if (!orders.length) {
        this.$message.warning('请先勾选已确认的销售订单')
        return
      }
      this.mergePushVisible = true
      this.$nextTick(() => this.$refs.mergePush && this.$refs.mergePush.init({
        salesOrderIds: orders.map(r => r.salesOrderId),
        salesOrders: orders
      }))
    },
    onPushSuccess() {
      this.load()
      if (this.visible && this.form && this.form.salesOrderId) {
        docInfo('/sale/salesOrder', this.form.salesOrderId).then(res => {
          const data = res.data || {}
          this.form = Object.assign({}, this.form, data, { lines: data.lines || this.form.lines || [] })
          this.normalizeTaxes()
        }).catch(() => {})
      }
    },
    resolvePrices() {
      const ids = this.form.lines.map(line => line.materialId).filter(Boolean)
      if (!ids.length) return
      resolveSalePriceListPrices({ customerId: this.form.customerId, bizDate: this.form.orderDate, materialIds: ids }).then(res => {
        const list = (res.data && res.data.list) || []
        if (!list.length) { this.$message.warning('未匹配到价目表价格'); return }
        let matched = 0
        this.form.lines.forEach(line => {
          const hit = list.find(item => item.materialId === line.materialId)
          if (hit) {
            line.price = hit.price
            // 价目表按百分数录入税点，订单字典可能按小数保存（如 13 与 0.13）。
            if (hit.tax !== undefined && hit.tax !== null) line.tax = this.materialTax(hit.tax)
            matched++
          }
        })
        if (!matched) this.$message.warning('未匹配到价目表价格')
      }).catch(() => {})
    }
  }
}
</script>

<style scoped>
.list-pagination { margin-top: 10px; text-align: right; }
.code-link { color: #2563eb; cursor: pointer; }
.toolbar >>> .el-form-item { margin-bottom: 8px; }
.warn { color: #e6a23c; }
.doc-dialog-header { display: flex; align-items: center; justify-content: space-between; padding-right: 28px; }
.doc-dialog-title { font-size: 16px; font-weight: 600; }
</style>
